import { Component, signal } from '@angular/core';
import { UserPoolListComponent } from '../../../ui/admin/user-pool-list/user-pool-list.component';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';
import { AdminService } from '../../../../services/admin.service';
import { UserListComponent } from '../../../ui/admin/user-list/user-list.component';
import { GenerateEmailUsersComponent } from '../../../ui/admin/generate-email-users/generate-email-users.component';
import { GenerateUuidUsersComponent } from '../../../ui/admin/generate-uuid-users/generate-uuid-users.component';
import { CognitoUserFormComponent } from '../../../forms/standard/cognito-user-form/cognito-user-form.component';
import { LoginTrackingListComponent } from '../../../ui/admin/login-tracking-list/login-tracking-list.component';
import { Subscription } from 'rxjs';
import { CognitoUser, Course, LoginTracking } from '@mira-avant/mtlibs';
import { LoginTrackingService } from '../../../../services/login-tracking.service';
import { AuthService } from '../../../../services/auth.service';
import { UserSkillLevelComponent } from '../../../ui/admin/user-skill-level/user-skill-level.component';
import { UserSkillHistoryComponent } from '../../../ui/admin/user-skill-history/user-skill-history.component';
import { UserService } from '../../../../services/user.service';
import { CourseSelectorComponent } from '../../../ui/admin/course-selector/course-selector.component';
import { CognitoService } from '../../../../services/cognito.service';

@Component({
	selector: 'app-iam',
	standalone: true,
	imports: [
		UserPoolListComponent,
		AngularModule,
		ZorroModule,
		BreadcrumbsComponent,
		UserListComponent,
		GenerateEmailUsersComponent,
		GenerateUuidUsersComponent,
		CognitoUserFormComponent,
		LoginTrackingListComponent,
		UserSkillLevelComponent,
		UserSkillHistoryComponent,
		CourseSelectorComponent,
	],
	templateUrl: './iam.component.html',
	styleUrl: './iam.component.scss',
})
export class IamComponent {
	private sub: Subscription | undefined;

	readonly logins = signal<LoginTracking[]>([]);
	readonly isAdmin = signal<boolean>(false);
	readonly selectedUserClientUuids = signal<string[]>([]);
	readonly selectedCourse = signal<Course | undefined>(undefined);

	constructor(
		private authService: AuthService,
		public cognitoService: CognitoService,
		private loginTrackingService: LoginTrackingService,
		public adminService: AdminService,
		private userService: UserService
	) {
		this.authService.isAdmin$().then(admin => {
			this.isAdmin.set(admin);
		});
	}

	ngOnInit(): void {
		this.sub = this.adminService.selectedUser$.subscribe((cognitoUser: CognitoUser | undefined) => {
			if (!cognitoUser) {
				this.logins.set([]);
				this.selectedUserClientUuids.set([]);
				return;
			}

			this.userService.get$(cognitoUser.uuid, false, false, true).then(user => {
				this.selectedUserClientUuids.set(user?.user_client?.map(uc => uc.client_uuid) || []);
			});

			this.loginTrackingService.getLastLoginsByUser$(cognitoUser.uuid).then((logins: LoginTracking[]) => {
				this.logins.set(logins);
			});
		});
	}

	public selectCourse(course: Course | undefined): void {
		this.selectedCourse.set(course);
	}

	public async onCognitoUserFormSubmit$($event: any): Promise<void> {
		// Implementation can be added later if needed
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}
}
